import React from 'react'
import { Typography, Box } from '@mui/material'
import { DeepcellDialog } from 'components/shared'
import { PinnedMorphotype } from 'redux/slices'

interface OverlapWarningModalProps {
  open: boolean
  onClose: () => void
  onProceed: () => void
  onCancel: () => void
  overlappingMorphotypes: PinnedMorphotype[]
}

export const OverlapWarningModal: React.FC<OverlapWarningModalProps> = ({
  open,
  onClose,
  onProceed,
  onCancel,
  overlappingMorphotypes,
}) => {
  const handleCancel = () => {
    onCancel()
    onClose()
  }

  const handleConfirm = () => {
    onProceed()
    onClose()
  }

  return (
    <DeepcellDialog
      open={open}
      titleLabel="Overlapping Selection Detected"
      cancelLabel="Cancel"
      okLabel="Continue Anyway"
      showCancelButton
      handleCancel={handleCancel}
      handleConfirm={handleConfirm}
      maxWidth="sm"
      fullWidth
    >
      <Box sx={{ mb: 2 }}>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Your new selection overlaps with {overlappingMorphotypes.length} existing selection{overlappingMorphotypes.length === 1 ? '' : 's'}:
        </Typography>

        <Box sx={{ mb: 2 }}>
          {overlappingMorphotypes.map((morphotype) => (
            <Typography
              key={morphotype.id}
              variant="body1"
              sx={{
                fontWeight: 'medium',
                color: 'text.primary',
                mb: 0.5,
              }}
            >
              • {morphotype.name}
            </Typography>
          ))}
        </Box>

        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          Overlapping selections are not supported in classifier training. If you choose to train a
          classifier, please resolve the overlap by doing one of the following:
        </Typography>

        <Box component="ul" sx={{ mt: 1, pl: 2 }}>
          <Typography component="li" variant="body2" color="text.secondary">
            Drawing your selection in a different area
          </Typography>
          <Typography component="li" variant="body2" color="text.secondary">
            Merging the overlapping selections later
          </Typography>
          <Typography component="li" variant="body2" color="text.secondary">
            Deleting one of the existing selections first
          </Typography>
          <Typography component="li" variant="body2" color="text.secondary">
            Choosing to exclude your selection in the classifier training step
          </Typography>
        </Box>
      </Box>
    </DeepcellDialog>
  )
}

export default OverlapWarningModal
